import React, {useState, useEffect} from 'react'
import apiClient from '../api/apiClient'
import {useAuth} from '../context/AuthContext'
import {useNavigate} from 'react-router-dom'

export default function FinalExamList(){
    const {user} = useAuth()
    const userID = user.id

    const [testGroups, setTestGroups] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [studentList, setStudentList] = useState([])
    
    async function fetchTestGroups(){
        console.log("staring fetcing groups")
        try{
            const result = await apiClient.get('/api/testgroup/allfinaltestgroups', {
                params: {assessorID: userID}
            })

            console.log(result)
            setTestGroups(result.data)
        }catch(e){
            console.log(" fejl ved hent af final grades pg")
            console.log(e)
        }
    }

    async function fetchStudentList(){
        if(currentTestGroup === null){
            return;  
        }

        try{
            const result = await apiClient.get('/api/testgroup/getstudentsintestgroup', {
                params: {testGroupID: currentTestGroup.id}
            })
            setStudentList(result.data)
        }catch(e){
            console.log("fejl ved kald af final grades kursister")
            console.log(e)
        }
    }


    useEffect(()=>{
        fetchTestGroups()
        fetchStudentList()
    }, [currentTestGroup])

    const navigate = useNavigate()

    function handleStartFinalGrading(){
        navigate('/my-finalexamgrading', {state: {testGroupID : currentTestGroup.id}})
    }

    return(
        <div className="panel-container">
            <div className="panel">
              <select onChange={(e) => setCurrentTestGroup(testGroups.find(s=> s.id === parseInt(e.target.value)))}>
                <option key="0">Ingen prøvegruppe valgt</option>  
                {
                  testGroups.map(testGroup => (
                    <option key={testGroup.id} name={testGroup.id} value={testGroup.id}>{testGroup.navn}</option>
                  ))}
              </select>  
            <span>
                <b>Testgruppe: {currentTestGroup?.navn}</b>
            </span>
            {studentList.length === 0 ? (
                <p className="drop-zone-hint">
                    Ingen kursister
                </p>
            ):(
                <div>
                    <button type="button" onClick={handleStartFinalGrading}>Gå til afsluttende karaktergivning</button>
                    <table className="censor-table">
                        <thead>
                            <tr>
                                <th>Kursist ID</th>
                                <th>Fornavn(e)</th>
                                <th>Efternavn</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentList.map(student => (
                                <tr key={student.id}>
                                    <td>{student.id}</td>
                                    <td>{student.fornavne}</td>
                                    <td>{student.efternavn}</td>
                                </tr>
                                )   
                            )}
                        </tbody>
                    </table>
                </div>
            )}
            </div>
        </div>
    )
}